module.exports = __webpack_public_path__ + "media/flags/mr-59b9f4df.svg";